var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('LabelTableListing',{attrs:{"triggerSearch":_vm.triggerSearch,"triggerSearchName":_vm.triggerSearchName,"triggerTab":_vm.triggerTab}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }